// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ticket-form-item .el-form-item__label[data-v-5d110d95] {\n  width: 60px !important;\n}\n.ticket-form-item .el-form-item__content[data-v-5d110d95] {\n  margin-left: 60px !important;\n}", ""]);
// Exports
module.exports = exports;
